import React, { useState } from 'react';
import { Col, Container, Modal, Row, Button, Spinner } from 'react-bootstrap';
import '../assets/Styles/MapControlDispatchCSS/MapControlDispatch.css';


const DispatchRouteSummary = ({ routes = [], showDispatcRouteSummary, setShowDispatcRouteSummary }) => {
  const [filters, setFilters] = useState({});

  const handleFilterChange = (column, value) => {
    setFilters(prev => ({ ...prev, [column]: value }));
  };

  const filteredRoutes = routes.filter(route =>
    Object.entries(filters).every(([key, value]) =>
      !value || String(route[key]).toLowerCase().includes(value.toLowerCase())
    )
  );

  const handleCloseDispatchRouteSummaryDialog = () => {
    try{
        if (showDispatcRouteSummary) {
            setShowDispatcRouteSummary(false);
        }
    } catch(err){console.log(err);}
};


  return (
    <>
    {showDispatcRouteSummary &&
        <Modal backdrop="static" style={{fontFamily: "Roboto"}}
        show={showDispatcRouteSummary ? 1 : 0}
        keyboard={true}  size="lg" animation={true} onHide={handleCloseDispatchRouteSummaryDialog} 
        aria-labelledby="contained-modal-title-vcenter" dialogClassName="modal-tripDetails-width"
        centered
        >
        <Modal.Header className='dispatchRouteSummary_mh'>
            <Modal.Title>Route Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{background: "#dbdbdb", padding: "2px"}}>
            <Container>
            <table border="0" cellPadding="5" style={{fontSize: "small", width: "100%"}}>
            <thead>
                <tr style={{textAlign: "center", fontSize: "medium", paddingLeft: "0px"}}>
                <th style={{margin: "0px", padding: "0px"}}>
                    <div className='dispatchRouteSmry_tbl_hdr_lbl'>
                        <label>Rotue#</label>
                    </div>
                    <div style={{display: "inline-block",position: "relative",width: "100%"}}>
                    <input className='SearchHeaderInput'
                    placeholder='Search...'
                    type="text"
                    value={filters.routeName || ''}
                    onChange={e => handleFilterChange('routeName', e.target.value)}
                    />
                      <button
                        className='dispatchRouteSummary_tbl_ClearBtn'
                        onClick={() => handleFilterChange('routeName', '')}
                        aria-label="Clear filter"
                        type="button"
                        >×</button>
                        </div>
                </th>
                <th style={{margin: "0px", padding: "0px"}}>
                    <div className='dispatchRouteSmry_tbl_hdr_lbl'>
                        <label> Start Time</label>
                    </div>
                    <div style={{display: "inline-block",position: "relative",width: "100%"}}>
                    <input
                    placeholder='Search...'
                    className='SearchHeaderInput'
                    type="text"
                    value={filters.routeStartTime || ''}
                    onChange={e => handleFilterChange('routeStartTime', e.target.value)}
                    />
                      <button
                        className='dispatchRouteSummary_tbl_ClearBtn'
                        onClick={() => handleFilterChange('routeStartTime', '')}
                        aria-label="Clear filter"
                        type="button"
                        >×</button>
                              </div>
                </th>
                <th style={{margin: "0px", padding: "0px"}}>
                    <div className='dispatchRouteSmry_tbl_hdr_lbl'>
                        <label>End Time </label>
                    </div>
                    <div style={{ display: "inline-block",position: "relative",width: "100%"}}>
                    <input
                    placeholder='Search...'
                    className='SearchHeaderInput'
                    type="text"
                    value={filters.routeEndTime || ''}
                    onChange={e => handleFilterChange('routeEndTime', e.target.value)}
                    />
                      <button
                        className='dispatchRouteSummary_tbl_ClearBtn'
                        onClick={() => handleFilterChange('routeEndTime', '')}
                        aria-label="Clear filter"
                        type="button"
                        >×</button>
                              </div>
                </th>
                <th style={{margin: "0px", padding: "0px"}}>
                    <div className='dispatchRouteSmry_tbl_hdr_lbl'>
                        <label>No of Trips</label>
                    </div>
                    <div style={{display: "inline-block",position: "relative",width: "100%"}}>
                    <input
                    placeholder='Search...'
                    className='SearchHeaderInput'
                    type="text"
                    value={filters.noOfTrips || ''}
                    onChange={e => handleFilterChange('noOfTrips', e.target.value)}
                    />
                      <button
                        className='dispatchRouteSummary_tbl_ClearBtn'
                        onClick={() => handleFilterChange('noOfTrips', '')}
                        aria-label="Clear filter"
                        type="button"
                        >×</button>
                              </div>
                </th>
                <th style={{margin: "0px", padding: "0px"}}>
                    <div className='dispatchRouteSmry_tbl_hdr_lbl'>
                        <label>Vehicle</label>
                    </div>
                    <div style={{ display: "inline-block",position: "relative",width: "100%"}}>
                    <input
                    placeholder='Search...'
                    className='SearchHeaderInput'
                    type="text"
                    value={filters.vehicle || ''}
                    onChange={e => handleFilterChange('vehicle', e.target.value)}
                    />
                      <button
                        className='dispatchRouteSummary_tbl_ClearBtn'
                        onClick={() => handleFilterChange('vehicle', '')}
                        aria-label="Clear filter"
                        type="button"
                        >×</button>
                    </div>
                </th>
                <th style={{margin: "0px", padding: "0px"}}>
                    <div className='dispatchRouteSmry_tbl_hdr_lbl'>
                        <label>Driver</label>
                    </div>
                    <div style={{display: "inline-block",position: "relative",width: "100%"}}>
                    <input
                    placeholder='Search...'
                    className='SearchHeaderInput'
                    type="text"
                    value={filters.driver || ''}
                    onChange={e => handleFilterChange('driver', e.target.value)}
                    />
                      <button
                        className='dispatchRouteSummary_tbl_ClearBtn'
                        onClick={() => handleFilterChange('driver', '')}
                        aria-label="Clear filter"
                        type="button"
                        >×</button>
                              </div>
                </th>
                <th style={{margin: "0px", padding: "0px"}}>
                    <div className='dispatchRouteSmry_tbl_hdr_lbl'>
                        <label>Mobility Attributes</label>
                    </div>
                    <div style={{display: "inline-block",position: "relative",width: "100%"}}>
                    <input
                    placeholder='Search...'
                    className='SearchHeaderInput'
                    type="text"
                    value={filters.mobilityAttributes || ''}
                    onChange={e => handleFilterChange('mobilityAttributes', e.target.value)}
                    />
                    <button
                        className='dispatchRouteSummary_tbl_ClearBtn'
                        onClick={() => handleFilterChange('mobilityAttributes', '')}
                        aria-label="Clear filter"
                        type="button"
                        >×</button>
                    </div>
                </th>
                <th style={{margin: "0px", padding: "0px"}}>
                {/* <div className='dispatchRouteSmry_tbl_hdr_lbl'>
                        <label></label>
                </div>
                <div style={{display: "inline-block",position: "relative",width: "100%"}}>
                </div> */}
                </th>
                </tr>
            </thead>
            <tbody className='DispatchRouteSumry_TblBorder'>
                {filteredRoutes.map((route, index) => (
                <tr key={index} style={{textAlign: "center"}}>
                    <td className='dispatchRouteSmry_tbl_custom-td'>{route.routeName}</td>
                    <td className='dispatchRouteSmry_tbl_custom-td'>{route.routeStartTime}</td>
                    <td className='dispatchRouteSmry_tbl_custom-td'>{route.routeEndTime}</td>
                    <td className='dispatchRouteSmry_tbl_custom-td'>{route.noOfTrips}</td>
                    <td className='dispatchRouteSmry_tbl_custom-td'>{route.vehicle}</td>
                    <td className='dispatchRouteSmry_tbl_custom-td'>{route.driver}</td>
                    <td className='dispatchRouteSmry_tbl_custom-td'>{route.mobilityAttributes}</td>
                    <td className='dispatchRouteSmry_tbl_custom-td'>
                        <button className='tripaction_btn_color tripaction_btn_width btn btn-primary' onClick={() => alert(`Dispatching ${route.routeName}`)}>
                            Dispatch
                        </button>
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
            </Container>
        </Modal.Body>
        <Modal.Footer className='dispatchRouteSummary_mf'>
            <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDispatcRouteSummary(false)}>
                {"OK"}
            </Button>
        </Modal.Footer>
        </Modal>
    }
    </>
  );
};

export default DispatchRouteSummary;
